import { Box, Card, Typography, Grid, TextField, MenuItem, Button, IconButton } from '@mui/material'
import React, { useState, useEffect } from 'react'
import Header from '../Header'
import { styles } from '../../styles/styles';
import { DecorativeCorner } from '../../common/DecorativeCorner';
import { useLocation } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PersonIcon from "@mui/icons-material/Person";
import BlockIcon from '@mui/icons-material/Block';
import SendIcon from "@mui/icons-material/Send";
import DoneIcon from '@mui/icons-material/Done';
import ReplyIcon from '@mui/icons-material/Reply';
import InfoIcon from '@mui/icons-material/Info';
import Footer from '../Footer';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const Interests = () => {
    const navigate=useNavigate();
    const location = useLocation();
    const quickdetalies = location.state?.Interest;
    const advancedlocation = location.state?.InterestViewed;
    const serachbyidlocationfetch = location.state?.InterestAccepted;
    const view = location.state?.InterestReceived;
    const locationignored = useLocation();
    const ignored = locationignored.state?.InterestIgnored;
    const [quick, setQuick] = useState(false);
    const [advanced, setAdvanced] = useState(false);
    const [idsearch, setIdSearch] = useState(false);
    const [viewdetalies, setViewdetalies] = useState(false);
    const [clickedButton, setClickedButton] = useState(null);
    const [ignoredetalies, setIgnoredDetalies] = useState(false);
    useEffect(() => {
        if (quickdetalies === "Interests") {
            setQuick(true);
            setClickedButton("Interest Sent");
        }
    }, [quickdetalies]);

    useEffect(() => {
        if (advancedlocation === "Interests") {
            setAdvanced(true);
            setClickedButton("Interest Viewed");
        }
    }, [advancedlocation]);

    useEffect(() => {
        if (serachbyidlocationfetch === "Interests") {
            setIdSearch(true);
            setClickedButton("Interest Accepted");
        }
    }, [serachbyidlocationfetch]);
    useEffect(() => {
        if (view === "Interests") {
            setViewdetalies(true);
            setClickedButton("Interest Received");
        }
    }, [view]);
    useEffect(() => {
        if (ignored === "Interests") {
            setViewdetalies(true);
            setClickedButton("Interest Ignored");
        }
    }, [ignored]);
    const handleClick = (button) => {
        setClickedButton(button);
        setQuick(button === "Interest Sent");
        setAdvanced(button === "Interest Viewed");
        setIdSearch(button === "Interest Accepted");
        setViewdetalies(button === "Interest Received");
        setIgnoredDetalies(button === "Interest Ignored");
    };
    const Shortlisted = [
        {
            id: 1,
            image: "/images/women.jpeg",
            name: "Gayatri Devi",
            profession: "Software Engineer",
            Profileid: "AM101302",
            Age: "28",
            Location: "Bangalore",
        },
        {
            id: 2,
            image: "/images/women.jpeg",
            name: "Gayatri Devi",
            profession: "Software Engineer",
            Profileid: "AM102345",
            Age: "30",
            Location: "Hyderabad",
        },
        {
            id: 3,
            name: "Gayatri Devi",
            image: "/images/women.jpeg",
            profession: "Software Engineer",
            Profileid: "AM103567",
            Age: "26",
            Location: "Chennai",
        },

    ];
    return (
        <Box>
            <Header />
            
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: { xs: "35%", sm: "10%" },
                    gap: "20px",
                    flexDirection: { xs: "column", sm: "row" },
                }}
            >
                <Card
                    sx={{
                        padding: "8.55px",
                        borderRadius: "854.41px",
                        width: "307px",
                        height: "112.89px",
                        gap: "8.55px",
                        display: "flex",
                        alignItems: "center",
                        border: "2px solid rgb(226, 122, 24)",

                        justifyContent: "center",
                        textAlign: "center",
                        backgroundColor: clickedButton === "Interest Sent" ? "rgb(224, 141, 64)" : "#fff",
                        color: clickedButton === "Interest Sent" ? "#fff" : "inherit",
                        "&:hover": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                        "&:active": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                    }}
                    onClick={() => handleClick("Interest Sent")}
                >
                    <Typography sx={{ fontFamily: "SF Pro Display, sans-serif", fontWeight: 700, fontSize: "27.37px", cursor: "pointer" }}>
                        Interest Sent
                    </Typography>
                </Card>
                <Card
                    sx={{
                        padding: "8.55px",
                        borderRadius: "854.41px",
                        width: "307px",
                        height: "112.89px",
                        gap: "8.55px",
                        display: "flex",
                        border: "2px solid rgb(226, 122, 24)",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        backgroundColor: clickedButton === "Interest Viewed" ? "rgb(224, 141, 64)" : "#fff",
                        color: clickedButton === "Interest Viewed" ? "#fff" : "inherit",
                        "&:hover": { backgroundColor: "rgb(224, 141, 64)", color: "#fff", border: "1px solid rgb(224, 141, 64)" },
                        "&:active": { backgroundColor: "rgb(224, 141, 64)", color: "#fff", },
                    }}
                    onClick={() => handleClick("Interest Viewed")}
                >
                    <Typography sx={{ fontFamily: "SF Pro Display, sans-serif", fontWeight: 700, fontSize: "27.37px", cursor: "pointer" }}>
                        Interest Viewed
                    </Typography>
                </Card>
                <Card
                    sx={{
                        padding: "8.55px",
                        borderRadius: "854.41px",
                        width: "307px",
                        height: "112.89px",
                        gap: "8.55px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        border: "2px solid rgb(226, 122, 24)",

                        backgroundColor: clickedButton === "Interest Accepted" ? "rgb(224, 141, 64)" : "#fff",
                        color: clickedButton === "Interest Accepted" ? "#fff" : "inherit",
                        "&:hover": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                        "&:active": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                    }}
                    onClick={() => handleClick("Interest Accepted")}
                >
                    <Typography sx={{ fontFamily: "SF Pro Display, sans-serif", fontWeight: 700, fontSize: "27.37px", cursor: "pointer" }}>
                        Interest Accepted
                    </Typography>
                </Card>
                <Card
                    sx={{
                        padding: "8.55px",
                        borderRadius: "854.41px",
                        width: "307px",
                        height: "112.89px",
                        gap: "8.55px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        border: "2px solid rgb(226, 122, 24)",

                        backgroundColor: clickedButton === "Interest Received" ? "rgb(224, 141, 64)" : "#fff",
                        color: clickedButton === "Interest Received" ? "#fff" : "inherit",
                        "&:hover": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                        "&:active": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                    }}
                    onClick={() => handleClick("Interest Received")}
                >
                    <Typography sx={{ fontFamily: "SF Pro Display, sans-serif", fontWeight: 700, fontSize: "27.37px", cursor: "pointer" }}>
                        Interest Received
                    </Typography>
                </Card>
                <Card
                    sx={{
                        padding: "8.55px",
                        borderRadius: "854.41px",
                        width: "307px",
                        height: "112.89px",
                        gap: "8.55px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        border: "2px solid rgb(226, 122, 24)",

                        backgroundColor: clickedButton === "Interest Ignored" ? "rgb(224, 141, 64)" : "#fff",
                        color: clickedButton === "Interest Ignored" ? "#fff" : "inherit",
                        "&:hover": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                        "&:active": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                    }}
                    onClick={() => handleClick("Interest Ignored")}
                >
                    <Typography sx={{ fontFamily: "SF Pro Display, sans-serif", fontWeight: 700, fontSize: "27.37px", cursor: "pointer" }}>
                        Interest Ignored                        </Typography>
                </Card>
            </Box>;
            {
                quick && (
                    <Card
                        sx={{
                            ...styles.cardShortlisted,
                            marginTop: { xs: "10%", sm: "3%" },
                            height: "100%",
                            padding: { xs: "10%", sm: "40px" },
                        }}
                    >
                        <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                        <Grid container spacing={3}>
                            {Shortlisted.map((profile) => (
                                <Grid item xs={12} sm={4} key={profile.id}>
                                    <Card
                                        sx={{
                                            textAlign: "center",
                                            width: "100%",
                                            maxWidth: "300px",
                                            padding: { xs: "15px", sm: "10px 10px" },
                                            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                            border: "2px solid rgb(224, 141, 64)",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: 2,
                                            margin: "0 auto",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: "center",
                                                gap: 3,
                                                textAlign: { xs: "center", sm: "left" },
                                            }}
                                        >
                                            <img
                                                src={profile.image}
                                                alt={profile.name}
                                                style={{ width: "80px", height: "80px", borderRadius: "50%" }}
                                            />
                                            <Box>
                                                <Typography variant="h6" sx={{ fontWeight: "bold", color: "rgba(198, 61, 15, 1)" }}>
                                                    {profile.name}
                                                </Typography>
                                                <Typography sx={{ fontSize: "14px", color: "gray" }}>
                                                    {profile.profession}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box
                                            sx={{
                                                textAlign: "center",
                                                width: "100%",
                                                padding: { xs: "0 10px", sm: "0 50px" },
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Profile ID:</span>
                                                <span>{profile.Profileid}</span>
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Age:</span>
                                                <span>{profile.Age}</span>
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Location:</span>
                                                <span>{profile.Location}</span>
                                            </Typography>
                                        </Box>


                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: 2,
                                                marginTop: "10px",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            <PersonIcon
                                                sx={{
                                                    backgroundColor: "rgb(147, 93, 13)",
                                                    width: "40px",
                                                    height: "40px",
                                                    color: "white",
                                                    padding: { xs: "6px", sm: "2px" },
                                                    borderRadius: "5px",
                                                    fontSize: { xs: "40px", sm: "30px" },
                                                }}
                                            />

                                            <Button
                                                variant="contained"
                                                sx={{

                                                    width: "200px",
                                                    height: "40px",
                                                    fontSize: { xs: "15px", sm: "16px" },
                                                    radius: "4px",
                                                    gap: 2,
                                                    backgroundColor: "green",
                                                    color: "white ",
                                                    fontFamily: "SF Pro Display"
                                                }}
                                            >
                                                < SendIcon
                                                    sx={{
                                                        color: "white",
                                                        padding: { xs: "6px", sm: "2px" },
                                                        borderRadius: "5px",
                                                        fontSize: { xs: "40px", sm: "30px" },
                                                    }}
                                                />
                                                Interest Sent
                                            </Button>

                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Card>
                )
            }
            {
                advanced && (
                    <Card
                        sx={{
                            ...styles.cardShortlisted,
                            marginTop: { xs: "10%", sm: "3%" },
                            height: "100%",
                            padding: { xs: "10%", sm: "40px" },
                        }}
                    >
                        <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                        <Grid container spacing={2}>
                            {Shortlisted.map((profile) => (
                                <Grid item xs={12} sm={4} key={profile.id}>
                                    <Card
                                        sx={{
                                            textAlign: "center",
                                            width: "100%",
                                            maxWidth: "300px",
                                            padding: { xs: "15px", sm: "10px 10px" },
                                            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                            border: "2px solid rgb(224, 141, 64)",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: 2,
                                            margin: "0 auto",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: "center",
                                                gap: 3,
                                                textAlign: { xs: "center", sm: "left" },
                                            }}
                                        >
                                            <img
                                                src={profile.image}
                                                alt={profile.name}
                                                style={{ width: "80px", height: "80px", borderRadius: "50%" }}
                                            />
                                            <Box>
                                                <Typography variant="h6" sx={{ fontWeight: "bold", color: "rgba(198, 61, 15, 1)" }}>
                                                    {profile.name}
                                                </Typography>
                                                <Typography sx={{ fontSize: "14px", color: "gray" }}>
                                                    {profile.profession}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box
                                            sx={{
                                                textAlign: "center",
                                                width: "100%",
                                                padding: { xs: "0 10px", sm: "0 50px" },
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Profile ID:</span>
                                                <span>{profile.Profileid}</span>
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Age:</span>
                                                <span>{profile.Age}</span>
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Location:</span>
                                                <span>{profile.Location}</span>
                                            </Typography>
                                        </Box>


                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: 2,
                                                marginTop: "10px",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            <PersonIcon
                                                sx={{
                                                    backgroundColor: "rgb(147, 93, 13)",
                                                    width: "40px",
                                                    height: "40px",
                                                    color: "white",
                                                    padding: { xs: "6px", sm: "2px" },
                                                    borderRadius: "5px",
                                                    fontSize: { xs: "40px", sm: "30px" },
                                                }}
                                            />

                                            <Button
                                                variant="contained"
                                                sx={{

                                                    width: "200px",
                                                    height: "40px",
                                                    fontSize: { xs: "15px", sm: "16px" },
                                                    radius: "4px",
                                                    backgroundColor: "rgb(147, 93, 13)",
                                                    color: "white ",
                                                    fontFamily: "SF Pro Display"
                                                }}
                                            >
                                                <SendIcon
                                                    sx={{
                                                        color: "white",
                                                        padding: { xs: "6px", sm: "2px" },
                                                        borderRadius: "5px",
                                                        fontSize: { xs: "40px", sm: "20px" },
                                                    }}
                                                />
Interest Viewed                                                
 </Button>

                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Card>
                )
            }
            {
                idsearch && (
                    <Card
                        sx={{
                            ...styles.cardShortlisted,
                            marginTop: { xs: "10%", sm: "3%" },
                            height: "100%",
                            padding: { xs: "10%", sm: "40px" },
                        }}
                    >
                        <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                        <Grid container spacing={3}>
                            {Shortlisted.map((profile) => (
                                <Grid item xs={12} sm={4} key={profile.id}>
                                    <Card
                                        sx={{
                                            textAlign: "center",
                                            width: "100%",
                                            maxWidth: "300px",
                                            padding: { xs: "15px", sm: "10px 10px" },
                                            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                            border: "2px solid rgb(224, 141, 64)",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: 2,
                                            margin: "0 auto",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: "center",
                                                gap: 3,
                                                textAlign: { xs: "center", sm: "left" },
                                            }}
                                        >
                                            <img
                                                src={profile.image}
                                                alt={profile.name}
                                                style={{ width: "80px", height: "80px", borderRadius: "50%" }}
                                            />
                                            <Box>
                                                <Typography variant="h6" sx={{ fontWeight: "bold", color: "rgba(198, 61, 15, 1)" }}>
                                                    {profile.name}
                                                </Typography>
                                                <Typography sx={{ fontSize: "14px", color: "gray" }}>
                                                    {profile.profession}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box
                                            sx={{
                                                textAlign: "center",
                                                width: "100%",
                                                padding: { xs: "0 10px", sm: "0 50px" },
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Profile ID:</span>
                                                <span>{profile.Profileid}</span>
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Age:</span>
                                                <span>{profile.Age}</span>
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Location:</span>
                                                <span>{profile.Location}</span>
                                            </Typography>
                                        </Box>


                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: 2,
                                                marginTop: "10px",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            <PersonIcon
                                                sx={{
                                                    backgroundColor: "rgb(147, 93, 13)",
                                                    width: "40px",
                                                    height: "40px",
                                                    color: "white",
                                                    padding: { xs: "6px", sm: "2px" },
                                                    borderRadius: "5px",
                                                    fontSize: { xs: "40px", sm: "30px" },
                                                }}
                                            />

                                            <Button
                                                variant="contained"
                                                sx={{

                                                    width: "200px",
                                                    height: "40px",
                                                    fontSize: { xs: "15px", sm: "16px" },
                                                    radius: "4px",
                                                    gap: 1,
                                                    backgroundColor: "green",
                                                    color: "white ",
                                                    fontFamily: "SF Pro Display"
                                                }}
                                            >
                                                <DoneIcon
                                                    sx={{
                                                        color: "white",
                                                        padding: { xs: "6px", sm: "2px" },
                                                        borderRadius: "5px",
                                                        fontSize: { xs: "40px", sm: "30px" },
                                                    }}
                                                />
                                                Profile Viewed                                           </Button>

                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Card>
                )
            }
            {
                viewdetalies && (
                    <Card
                        sx={{
                            ...styles.cardShortlisted,
                            marginTop: { xs: "10%", sm: "3%" },
                            height: "100%",
                            padding: { xs: "10%", sm: "40px" },
                        }}
                    >
                        <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                        <Grid container spacing={3}>
                            {Shortlisted.map((profile) => (
                                <Grid item xs={12} sm={4} key={profile.id}>
                                    <Card
                                        sx={{
                                            textAlign: "center",
                                            width: "100%",
                                            maxWidth: "300px",
                                            padding: { xs: "15px", sm: "10px 10px" },
                                            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                            border: "2px solid rgb(224, 141, 64)",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: 2,
                                            margin: "0 auto",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: "center",
                                                gap: 3,
                                                textAlign: { xs: "center", sm: "left" },
                                            }}
                                        >
                                            <img
                                                src={profile.image}
                                                alt={profile.name}
                                                style={{ width: "80px", height: "80px", borderRadius: "50%" }}
                                            />
                                            <Box>
                                                <Typography variant="h6" sx={{ fontWeight: "bold", color: "rgba(198, 61, 15, 1)" }}>
                                                    {profile.name}
                                                </Typography>
                                                <Typography sx={{ fontSize: "14px", color: "gray" }}>
                                                    {profile.profession}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box
                                            sx={{
                                                textAlign: "center",
                                                width: "100%",
                                                padding: { xs: "0 10px", sm: "0 50px" },
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Profile ID:</span>
                                                <span>{profile.Profileid}</span>
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Age:</span>
                                                <span>{profile.Age}</span>
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexDirection: { xs: "column", sm: "row" },
                                                    gap: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                <span style={{ fontWeight: "bold" }}>Location:</span>
                                                <span>{profile.Location}</span>
                                            </Typography>
                                        </Box>


                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                gap: 2,
                                                marginTop: "10px",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            <PersonIcon
                                                sx={{
                                                    backgroundColor: "rgb(147, 93, 13)",
                                                    width: "40px",
                                                    height: "40px",
                                                    color: "white",
                                                    padding: { xs: "6px", sm: "2px" },
                                                    borderRadius: "5px",
                                                    fontSize: { xs: "40px", sm: "30px" },
                                                }}
                                            />

                                            <Button
                                                variant="contained"
                                                sx={{

                                                    width: "200px",
                                                    height: "40px",
                                                    fontSize: { xs: "15px", sm: "15px" },
                                                    radius: "4px",
                                                    gap: 1,
                                                    backgroundColor: "green",
                                                    color: "white ",
                                                    fontFamily: "SF Pro Display"
                                                }}
                                            >
                                                <ReplyIcon
                                                    sx={{
                                                        color: "white",
                                                        padding: { xs: "6px", sm: "2px" },
                                                        borderRadius: "5px",
                                                        fontSize: { xs: "40px", sm: "30px" },
                                                    }}
                                                />
                                                Viewed My Profile
                                            </Button>

                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Card>
                )
            }
            {
                ignoredetalies &&(
                    <Card
                    sx={{
                        ...styles.cardShortlisted,
                        marginTop: { xs: "10%", sm: "3%" },
                        height: "100%",
                        padding: { xs: "10%", sm: "40px" },
                    }}
                >
                    <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                    <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                    <Grid container spacing={3}>
                        {Shortlisted.map((profile) => (
                            <Grid item xs={12} sm={4} key={profile.id}>
                                <Card
                                    sx={{
                                        textAlign: "center",
                                        width: "100%",
                                        maxWidth: "300px",
                                        padding: { xs: "15px", sm: "10px 10px" },
                                        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                        border: "2px solid rgb(224, 141, 64)",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 2,
                                        margin: "0 auto",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", sm: "row" },
                                            alignItems: "center",
                                            gap: 3,
                                            textAlign: { xs: "center", sm: "left" },
                                        }}
                                    >
                                        <img
                                            src={profile.image}
                                            alt={profile.name}
                                            style={{ width: "80px", height: "80px", borderRadius: "50%" }}
                                        />
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "rgba(198, 61, 15, 1)" }}>
                                                {profile.name}
                                            </Typography>
                                            <Typography sx={{ fontSize: "14px", color: "gray" }}>
                                                {profile.profession}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box
                                        sx={{
                                            textAlign: "center",
                                            width: "100%",
                                            padding: { xs: "0 10px", sm: "0 50px" },
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: "14px",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                flexDirection: { xs: "column", sm: "row" },
                                                gap: { xs: 1, sm: 0 },
                                            }}
                                        >
                                            <span style={{ fontWeight: "bold" }}>Profile ID:</span>
                                            <span>{profile.Profileid}</span>
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontSize: "14px",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                flexDirection: { xs: "column", sm: "row" },
                                                gap: { xs: 1, sm: 0 },
                                            }}
                                        >
                                            <span style={{ fontWeight: "bold" }}>Age:</span>
                                            <span>{profile.Age}</span>
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontSize: "14px",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                flexDirection: { xs: "column", sm: "row" },
                                                gap: { xs: 1, sm: 0 },
                                            }}
                                        >
                                            <span style={{ fontWeight: "bold" }}>Location:</span>
                                            <span>{profile.Location}</span>
                                        </Typography>
                                    </Box>


                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: 2,
                                            marginTop: "10px",
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        <PersonIcon
                                            sx={{
                                                backgroundColor: "rgb(147, 93, 13)",
                                                width: "40px",
                                                height: "40px",
                                                color: "white",
                                                padding: { xs: "6px", sm: "2px" },
                                                borderRadius: "5px",
                                                fontSize: { xs: "40px", sm: "30px" },
                                            }}
                                        />

                                        <Button
                                            variant="contained"
                                            sx={{

                                                width: "200px",
                                                height: "40px",
                                                fontSize: { xs: "15px", sm: "15px" },
                                                radius: "4px",
                                                gap: 1,
                                                backgroundColor: "rgba(198, 61, 15, 1)",
                                                color: "white ",
                                                fontFamily: "SF Pro Display"
                                            }}
                                        >
                                            <InfoIcon
                                                sx={{
                                                    color: "white",
                                                    padding: { xs: "6px", sm: "2px" },
                                                    borderRadius: "5px",
                                                    fontSize: { xs: "40px", sm: "30px" },
                                                }}
                                            />
                                            Viewed My Profile
                                        </Button>

                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Card>
                )
            }
            <Footer/>
        </Box>
    )
}

export default Interests
